import Button from "@/common/components/Button";
import Modal from "@/common/components/Modal";
import { ModalMessageSimple } from "@/common/components/ModalMessageSimple";
import { FormTransformers } from "@/common/utils/formTransformers";
import { useMaintenanceFinancialReviewSimpleEntriesReject } from "@/features/privateCompanies/pages/Maintenance/Workflows/Show/hooks/forwardings/financialReview/simpleEntries/useMaintenanceFinancialReviewSimpleEntriesReject";
import { useForwardingTabContext } from "@/features/privateCompanies/pages/Maintenance/Workflows/Show/hooks/forwardings/useForwardingTabContext";
import { useQueryClient } from "@tanstack/react-query";
import { useState } from "react";
import { useParams } from "react-router-dom";

const FinancialReviewEntrySimpleEntryReject = () => {
  const { workflow, forwarding } = useForwardingTabContext();

  const { id } = useParams();

  const queryClient = useQueryClient();

  const [messages, setMessages] = useState<string[] | boolean>(false);

  const {
    mutate: reject,
    isPending: rejectIsPending,
  } = useMaintenanceFinancialReviewSimpleEntriesReject({
    financialReviewEntryId: workflow?.current_forwarding?.financial_review_entry?.id,
    options: {
      onSuccess: () => {
        queryClient.invalidateQueries({
          queryKey: ['maintenanceForwarding', forwarding.id],
        });

        queryClient.invalidateQueries({
          queryKey: ['maintenanceWorkflow', id],
        });
      },
      onError: (error) => {
        FormTransformers.errorsTransformer({
          setMessages,
        })(error);
      }
    }
  });

  return (
    <>
      <Modal
        Trigger={(
          <Button
            variant="yellow"
            operationKlassToCheckPermission="Admin::Maintenance::FinancialReview::SimpleEntries::Reject"
          >
            Declinar
          </Button>
        )}
        useCancellableFooter
        confirmButtonClassName="rounded-br-lg"
        cancelButtonClassName="rounded-bl-lg"
        onConfirm={() => reject()}
        confirmButtonIsLoading={rejectIsPending}
        title="Você tem certeza?"
        subtitle="Essa ação não é reversível."
        titleClass="text-2xl"
        subtitleClassName="text-base mt-1"
        showClose={false}
      />

      <ModalMessageSimple
        messages={messages}
        setMessages={setMessages}
        isError
      />
    </>
  );
}

export default FinancialReviewEntrySimpleEntryReject;
